

import { Component, Vue } from "vue-property-decorator";
import ParticaBaseView from "./ParticaBaseView.vue";
import { BreadcrumbItem } from "../../Models/Breadcrumb";

@Component({
	name: "ParticaWebsiteBase"
})
export default class ParticaWebsiteBase extends ParticaBaseView {
	protected navAccountId: number = 0;
	protected metadata: any = { page: "website", name: "" };

	protected async getWebsiteNav(id: number) {
		let title: string = "";
		this.navData = await this.navigationService.GetNavData(id, this.metadata.page, this.stateconfig.accountid);
		if (this.navData !== undefined) {

			if (this.navData.parentName !== null && this.navData.parentName !== undefined) {
				title += " : " + this.navData.parentName;
			}
			if (this.navData.name !== null && this.navData.name !== undefined) {
				title += " : " + this.navData.name;
			}
		}
		this.setPageTitle(title);
		this.breadcrumbs = [
			{ text: this.navData.parentName, to: `/${this.navData.parentId}/home/`, disabled: false, exact: true } as BreadcrumbItem,
			{ text: "Websites", to: `/websites/${this.navData.parentId}/`, disabled: false, exact: true } as BreadcrumbItem,
			{ text: this.navData.name, to: `/website/${this.navData.id}/`, disabled: false, exact: true } as BreadcrumbItem,
			{ text: this.metadata.name, to: ``, disabled: true, exact: true } as BreadcrumbItem
		];

	}
}
